function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000,123.000000) scale(0.100000,-0.100000)",
  fill: "#000000",
  stroke: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M462 1210 c-341 -92 -539 -447 -433 -780 58 -185 218 -343 406 -403 55 -17 94 -22 180 -22 86 0 125 5 180 22 191 61 348 217 408 408 31 99 31 261 0 360 -60 189 -216 347 -403 406 -95 31 -244 35 -338 9z m-42 -245 c37 -19 50 -43 50 -94 0 -28 -7 -48 -25 -70 l-26 -30 31 -60 c16 -33 30 -65 30 -71 0 -5 -13 -10 -30 -10 -25 0 -33 8 -65 65 -32 57 -40 65 -66 65 l-29 0 0 -65 0 -65 -35 0 -35 0 0 175 0 175 85 0 c57 0 96 -5 115 -15z m348 3 c-2 -7 -65 -172 -139 -365 -132 -349 -134 -353 -162 -353 -19 0 -27 5 -25 13 2 8 64 172 138 365 134 350 135 352 163 352 19 0 28 -4 25 -12z m191 -441 c33 -90 61 -169 61 -175 0 -7 -13 -12 -30 -12 -25 0 -31 5 -41 40 l-12 40 -67 0 -67 0 -12 -40 c-11 -37 -15 -40 -46 -40 l-35 0 25 68 c107 284 106 282 135 282 26 0 30 -7 89 -163z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M290 870 l0 -50 40 0 c27 0 47 7 60 20 24 24 24 29 4 58 -12 17 -25 22 -60 22 l-44 0 0 -50z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M847 541 c-9 -27 -17 -51 -17 -55 0 -3 18 -6 41 -6 31 0 40 3 36 14 -3 8 -11 32 -18 55 -7 23 -15 41 -18 41 -4 0 -14 -22 -24 -49z"
}));

function SvgResoluteApparelLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "123.000000pt",
    height: "123.000000pt",
    viewBox: "0 0 123.000000 123.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResoluteApparelLogo);
export default __webpack_public_path__ + "static/media/resolute-apparel-logo.fafd1d0b.svg";
export { ForwardRef as ReactComponent };